import {
  APP_BASE_PATH,
  APPLY_FDR_URL,
  ABOUT_PAGE_ORGANIZATION_SCHEMA,
} from '../../../../common/constants'
import { recommendedReadsData } from '../../consts'

const { howItWorks, whyWereBetter, testimonials } = recommendedReadsData
const TITLE = 'Who We Are (About Us) | Freedom Debt Relief'
const DESCRIPTION =
  'Debt relief is what we do. But the way we help you resolve your debt makes us who we are and shows you what we believe in.'
const URL = `${APP_BASE_PATH()}/about/`
export const aboutUsContent = {
  seo: {
    title: TITLE,
    description: DESCRIPTION,
    canonical: URL,
    openGraph: {
      title: TITLE,
      description: DESCRIPTION,
      url: URL,
      images: [
        {
          url: `${APP_BASE_PATH()}/next-assets/brand-pages/heros/about.webp`,
        },
      ],
      article: {
        authors: ['https://www.facebook.com/freedomdebtrelief'],
        modifiedTime: '2019-12-13T06:58:12+00:00',
      },
    },
  },
  heroData: {
    title: 'America’s leader in debt resolution',
    description: {
      nodeType: 'paragraph',
      content: [
        {
          nodeType: 'text',
          value:
            'As a leader in debt resolution, we help everyday people lift their debt burden to live the lives they want. ',
          marks: [],
        },
      ],
    },
    provenResult: {
      list: [
        { quantity: '1 million+', tagline: 'client served' },
        { quantity: '4 million+', tagline: 'accounts settled' },
        { quantity: '$20 billion+', tagline: 'in debt resolved' },
      ],
      showInMobile: true,
    },
    img: {
      src: '/next-assets/brand-pages/heros/about.webp',
      alt: 'happy parents and children',
    },
  },
  ourStoryData: {
    tagline: 'Our story',
    title: 'Your bridge to a better financial future',
    description: {
      nodeType: 'paragraph',
      content: [
        {
          nodeType: 'text',
          value:
            'Freedom Debt Relief, LLC is one of the largest debt settlement companies in the United States, specializing in helping consumers  \n' +
            'resolve unsecured debt, particularly credit card debt. Founded in 2002 and based in San Mateo, California, the company has  \n' +
            'served over one million clients and resolved more than $20 billion in debt. With a mission to bridge the gap in how major  \n' +
            'financial institutions serve everyday people, Freedom Debt Relief continues to provide debt solutions and education to  \n' +
            'resolve debt, build savings, and achieve financial freedom.',
          marks: [],
        },
      ],
    },
    hasLink: false,
    hasButton: false,
  },
  ourPrinciplesData: {
    tagline: 'Our principles',
    title: 'What you can count on',
    description: {
      nodeType: 'paragraph',
      content: [
        {
          nodeType: 'text',
          value:
            'Here’s how we resolve your debt using the principles we stand behind:',
          marks: [],
        },
      ],
    },
    hasLink: false,
    hasButton: false,
  },
  ourPrinciplesColumnData: [
    {
      logoName: 'humanApproch',
      title: 'A human approach',
      description: {
        nodeType: 'paragraph',
        content: [
          {
            nodeType: 'text',
            value:
              'No matter your situation, we’ll listen to you and treat you with respect, empathy, and understanding.',
            marks: [],
          },
        ],
      },
    },
    {
      logoName: 'movingForward',
      title: 'Moving you forward',
      description: {
        nodeType: 'paragraph',
        content: [
          {
            nodeType: 'text',
            value:
              'When you meet a goal, we’re here to help with the next. Every day, we’ll work together to push your finances in a better direction.',
            marks: [],
          },
        ],
      },
    },
    {
      logoName: 'solutions',
      title: 'Personalized solutions',
      description: {
        nodeType: 'paragraph',
        content: [
          {
            nodeType: 'text',
            value:
              'We’ll work with you to customize a solution to resolve debt so that it fits your life today, and gets you where you want to be in the future.',
            marks: [],
          },
        ],
      },
    },
    {
      logoName: 'smarter',
      title: 'Financially smarter',
      description: {
        nodeType: 'paragraph',
        content: [
          {
            nodeType: 'text',
            value:
              'We’ll teach you how to manage your money with confidence and transform how you think about your financial future.',
            marks: [],
          },
        ],
      },
    },
  ],
  featuredInData: [
    {
      name: 'motley',
      logo: '/next-assets/brand-pages/why-freedom/motley.webp',
      link: 'https://www.fool.com/the-ascent/research/waiving-credit-card-interest-saves-average-american-88-month/',
      alt: 'The Motley Fool',
    },
    {
      name: 'cnbs',
      logo: '/next-assets/brand-pages/why-freedom/cnbc.png',
      link: 'https://www.cnbc.com/2019/08/02/69percent-of-homeowners-wished-they-saved-more-for-downpayment.html',
      alt: 'CNBC',
    },
    {
      name: 'yahoo',
      logo: '/next-assets/brand-pages/why-freedom/yahoo.png',
      link: 'https://finance.yahoo.com/news/coronavirus-pandemic-household-income-survey-shows-155245815.html',
      alt: 'Yahoo Finance',
    },
    {
      name: 'usatoday',
      logo: '/next-assets/brand-pages/why-freedom/usatoday.png',
      link: 'https://www.usatoday.com/story/money/2020/02/12/credit-card-debt-average-balance-hits-6-200-and-limit-31-000/4722897002/',
      alt: 'USA today',
    },
    {
      name: 'msn',
      logo: '/next-assets/brand-pages/why-freedom/msn.png',
      link: 'https://www.msn.com/en-us/money/personalfinance/6-first-steps-post-grads-need-to-take-to-pay-off-student-debt/ar-AAYdJyN?li=BBnbfcL',
      alt: 'MSN',
    },
  ],
  blueSectionData: {
    title: 'An established business with experts on your side',
    hasMobileSubtitle: false,
    items: [
      {
        itemTitle: '200+',
        itemText: 'experienced debt negotiators',
        id: 'b29ce5ac9ce',
      },
      {
        itemTitle: '500+',
        itemText: 'certified debt consultants',
        id: 'b27139be026',
      },
      {
        itemTitle: '300+',
        itemText: 'customer service representatives',
        id: 'b27139be028',
      },
      {
        itemTitle: '1,600+',
        itemText: 'employees across the country',
        id: 'b27139be023',
      },
    ],
  },
  ourRecognitionData: {
    tagline: 'Our recognition',
    title: 'Promoting financial health and advocacy',
    description: {
      nodeType: 'paragraph',
      content: [
        {
          nodeType: 'text',
          value:
            'Freedom Debt Relief is a founding member of the ACDR and a member of multiple organizations committed to protecting \n consumers from abusive practices.',
          marks: [],
        },
      ],
    },
    button: {
      name: 'Get debt help',
      href: APPLY_FDR_URL(),
      showInMobile: true,
    },
    isLeadId: true,
    contact: {
      email: 'info@freedomdebtrelief.com',
      phone: '+18002301553',
      description:
        'For business matters, contact us by phone, or send us an email, and someone from our team will be in touch.',
    },
    achieveRelationship: {
      name: 'Understanding the relationship between Freedom Debt Relief and Achieve',
      href: '/about/freedom-debt-relief-and-achieve/',
    },
  },
  ourRecognitionSliderData: [
    {
      img: {
        src: '/next-assets/acdr-logo.webp',
        alt: 'Association for Consumer Debt Resolution',
      },
      title: 'Association for Consumer Debt Resolution',
      description:
        'The Association for Consumer Debt Resolution (ACDR) is dedicated to promoting and adhering to best practices in the debt resolution industry.',
    },
    {
      img: {
        src: '/next-assets/brand-pages/partners/bbb-desktop.webp',
        alt: 'Better Business Bureau BBB rating A+',
      },
      title: 'Better Business Bureau',
      description:
        'The Better Business Bureau (BBB)’s mission is to focus on advancing marketplace trust. Freedom Debt Relief is accredited by the BBB with an A+ rating.',
    },
    {
      img: {
        src: '/next-assets/brand-pages/partners/fhn.png',
        alt: 'financial health network',
      },
      title: 'Financial Health Network',
      description:
        'The Financial Health Network (FHN) unites industry, business leaders, policymakers, innovators, and visionaries committed to protecting consumers.',
    },
  ],

  recommendedReadsData: [howItWorks, whyWereBetter, testimonials],

  bottomSectionData: {
    title: `Make a difference in the lives of millions by joining our team`,
    list: [
      'People-first mentality',
      'Industry-leading success',
      'Remote-friendly positions',
    ],
    image: {
      src: '/next-assets/brand-pages/who-we-are/footer-man.png',
      alt: 'black male Freedom Debt Relief client',
    },
    isDark: false,
    buttonText: 'View openings',
    buttonLink: 'https://jobs.freedomfinancialnetwork.com/',
    showPhoneNumber: false,
    crawlable: false,
  },
  leadersData: {
    title: 'The people leading with heart',
    items: [
      {
        id: 'leader-1',
        imageAlt: 'leader 1',
        imageUrl: '/next-assets/brand-pages/leaders/leader-1.png',
        title: '',
        subtitle: '',
      },
      {
        id: 'leader-2',
        imageAlt: 'leader 2',
        imageUrl: '/next-assets/brand-pages/leaders/leader-2.png',
        title: '',
        subtitle: '',
      },
      {
        id: 'leader-3',
        imageAlt: 'leader 3',
        imageUrl: '/next-assets/brand-pages/leaders/leader-3.png',
        title: '',
        subtitle: '',
      },
      {
        id: 'leader-4',
        imageAlt: 'Sean Fox',
        imageUrl: '/next-assets/brand-pages/leaders/leader-4.png',
        title: '',
        subtitle: '',
      },
      {
        id: 'leader-5',
        imageAlt: 'Jason Pack',
        imageUrl: '/next-assets/brand-pages/leaders/leader-5.png',
        title: 'Jason Pack',
        subtitle: 'Chief Revenue Officer',
        href: '/about/jason-pack/',
      },
    ],
  },
  jsonLdData: {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    url: 'https://www.freedomdebtrelief.com/about/',
    name: 'Who We Are (About Us) | Freedom Debt Relief',
    description:
      "Learn about Freedom Debt Relief's mission, history, and commitment to helping Americans achieve financial freedom.",
    publisher: {
      ...ABOUT_PAGE_ORGANIZATION_SCHEMA,
    },
  },
  aboutPageSchemaData: {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    url: 'https://www.freedomdebtrelief.com/about/',
    name: 'Who We Are (About Us) | Freedom Debt Relief',
    description:
      "Learn about Freedom Debt Relief's mission, history, and commitment to helping Americans achieve financial freedom.",
    publisher: ABOUT_PAGE_ORGANIZATION_SCHEMA,
  },
}
